import React, { useState } from 'react';
import Navbar from '../../component/Navbar';
import Footer from '../../component/Footer';
import { Link } from 'react-router-dom';
import Arrow from '../Arrow';
import Generalsidebar from '../Generalsidebar';

function Premium() {
  const [showSidebar, setShowSidebar] = useState(false);

  const userInfo = JSON.parse(localStorage.getItem('userLoggedIn'))
    ? JSON.parse(localStorage.getItem('userLoggedIn'))
    : { firstName: '' };

  console.log('userInfo', userInfo);
  function handleArrowClick() {
    setShowSidebar(true);
  }

  return (
    <div className='bg-[#D9D9D9]'>
      <Navbar />

      <div onClick={handleArrowClick} className='absolute top-24 left-12 z-20'>
        <Arrow />
      </div>
      <div className={showSidebar ? 'show-sidebar' : 'hidden'}>
        <Generalsidebar setShowSidebar={setShowSidebar} />
      </div>

      <section className='container mx-auto mt-8 p-4 md:px-12 md:mb-6'>
        <h1 className='text-3xl font-semibold text-[#4D732A]'>
          Welcome to the Premium Dashboard
        </h1>
        <p className='mt-4 text-lg text-[#333]'>
          Unlock exclusive features and content with our premium plans.
        </p>
        <div className='mt-10 flex flex-col md:flex-row gap-6 '>
          {/* Full Premium Option */}
          <div className='bg-white rounded-lg p-6 flex-1'>
            <h2 className='text-2xl font-semibold text-[#4D732A]'>
              Full Premium Subscription
            </h2>
            <p className='mt-4 text-lg text-[#333]'>
              Enjoy unlimited access to premium features with our full premium
              plan.
            </p>
            <Link to='/mainpayment'>
              <button className='mt-4 bg-[#4D732A] text-white px-4 py-2 rounded hover:bg-[#385E20]'>
                Subscribe
              </button>
            </Link>
          </div>
          {/* Pay Per Session Option */}
          <div className='bg-white rounded-lg p-6 flex-1'>
            <h2 className='text-2xl font-semibold text-[#4D732A]'>
              Pay Per Session
            </h2>

            <p className='mt-4 text-lg text-[#333]'>
              Pay for individual sessions as you go with our pay-per-session
              option.
            </p>
            <a
              href='https://paystack.com/pay/thrive-pay-per-session'
              target='_blank'>
              <button className='mt-4 bg-[#4D732A] text-white px-4 py-2 rounded hover:bg-[#385E20]'>
                Book a Session
              </button>
            </a>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default Premium;
